<template>
  <div class="login">
    <div class="login__wrapper">
      <header class="login__title">
        <h1><img src="@/assets/icons/logo.gif" /></h1>
        <h2>HKTRC 網絡教學平台</h2>
      </header>
      <div class="login__content">
        <div v-if="isAnyError" class="login__content__status login__content__status--loading">
          Loading...
        </div>
        <div v-if="errorMsg !== ''" class="login__content__status login__content__status--error">
            <span>{{ errorMsg }}</span>
        </div>
        <div class="login__content__form">
          <div v-if="isLoginNotRegister">
            <div class="login__content__form__title">
              <h3>登入</h3>
            </div>
            <div class="login__content__form__error" v-if="performingRequest">
              載入中...
            </div>
            <div class="login__content__form__content">
              <form @submit.prevent>
                <label>電郵地址</label>
                <input
                  type="text"
                  placeholder="youremail@kiffon.app"
                  v-model.trim="loginForm.email"
                />
                <label>密碼</label>
                <input
                  type="password"
                  placeholder="********"
                  v-model.trim="loginForm.password"
                />
                <div class="submit">
                  <button
                    type="submit"
                    placeholder="Submit"
                    @click="signIn"
                  >
                    登入
                  </button>
                  <!--
                  <button
                    type="submit"
                    name="signUp"
                    placeholder="signUp"
                    @click="signUp"
                  >
                    註冊
                  </button>
                  -->
                </div>
              </form>
            </div>
          </div>

          <div v-else>
          </div>

          <footer class="footer">
            <div class="copyright">Powered by Kiffon Tech</div>
            <nav>
            </nav>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require('@/firebaseConfig.js')

export default {
  data () {
    return {
      isLoginNotRegister: true,
      isAnyError: false,
      performingRequest: false,
      errorMsg: '',
      currentStaffId: 'xm5uRrb6HiQsQWJ7jBJ3JaXDEJt1',
      currentStaffName: 'Jimmy Chu',
      currentStaffRole: 'Staff',
      currentShopId: '龍威大車房',
      currentShopName: '龍威大車房',
      loginForm: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    signIn () {
      this.performingRequest = true

      fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(credential => {
        this.$store.commit('setCurrentUser', credential.user)
        this.$store.dispatch('init')
        this.$router.push('/dashboard')
      }).catch(error => {
        console.log(error)
        this.performingRequest = false
        this.errorMsg = error.message
      })
    },
    signUp () {
      this.$router.push('/create')
    }
  }
}
</script>

<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css?family=Fredoka+One&display=swap');

.login {
  width: 100vw;
  height: 100vh;
  position: relative;
  top: 0;
  left: 0;
  font-size: 16px;
}
.login__wrapper {
  width: 300px;
  height: 620px;
  position: absolute;
  left: calc(50% - 150px);
  top: calc(50% - 310px);
}
.login__title {
  margin-top: 5rem;
  margin-bottom: 5rem;
  img {
    width: 150px;
  }
}
.login__content__form {
  .login__content__form__title {
    margin-bottom: 5rem;
  }
  .login__content__form__content {
    input[type=text], input[type=password] {
      border: 1px solid var(--color-grey-lighter);
      padding: 1rem;
      width: 90%;
      height: 20px;
      line-height: 20px;
      border-radius: 3px;
      margin: 1rem 0;
    }
     button {
      border: 1px solid var(--color-grey-lighter);
      width: 100%;
      height: 4em;
      line-height: 4em;
      border-radius: 3px;
      margin: 1rem 0;
      background: var(--color-grey-lighter-most);

      &[name=signUp] {
        background: #000;
        color: #FFF;
        border: 0;
      }
    }
    .submit {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      grid-gap: 2rem;
    }
  }
}
footer {
  position: absolute;
  bottom: 0;
  margin-bottom: 1rem;
  font-size: .8rem;
  line-height: 1.5rem;
}
</style>
